import { Button, Grid, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import convertDate from "../../utils/date.js";
import React, { useState } from "react";

const useStyles = makeStyles({
  root: {
    borderBottom: "1px solid #bbbbbb",
  },
});

export default function Note({ note, date, noteId, deleteNote, editNote }) {
  const styles = useStyles();
  const [editMode, toggleEditMode] = useState(false);
  const [newNote, setNewNote] = useState(note);

  const setEditMode = () => {
    if (editMode && note === newNote) {
      toggleEditMode(!editMode);
    } else {
      if (editMode && newNote !== "") {
        editNote(newNote, noteId);
        toggleEditMode(!editMode);
      } else {
        toggleEditMode(!editMode);
      }
    }
  };
  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      className={styles.root}
      mb={2}
      p={2}
    >
      <Grid
        container
        item
        xs={12}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>{convertDate(date)}</Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginRight: "10px" }}
            onClick={() => setEditMode(!editMode)}
          >
            {editMode ? "Save" : "Edit"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => deleteNote(noteId)}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {!editMode ? (
          note
        ) : (
          <>
            <TextField
              fullWidth
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
            ></TextField>
          </>
        )}
      </Grid>
    </Grid>
  );
}
